import { render, staticRenderFns } from "./myabonements.vue?vue&type=template&id=717ac5fc&scoped=true&"
import script from "./myabonements.vue?vue&type=script&lang=js&"
export * from "./myabonements.vue?vue&type=script&lang=js&"
import style0 from "./myabonements.vue?vue&type=style&index=0&id=717ac5fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ac5fc",
  null
  
)

export default component.exports